export default __webpack_public_path__ + "locales/fr/PaymentsEnterprise.json?hash=cd7ca5a9c8ee3fb372ca971a5eba752e";